// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoadingView_wrapper_1cp4c","spinner":"LoadingView_spinner_Fc75O"};